import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import type { Database } from "@frankly/shared-types";

type EdgeFunctionError = Database["public"]["Tables"]["edge_function_errors"]["Row"];

export function useEdgeFunctionErrors() {
  return useQuery({
    queryKey: ["edge_function_errors"],
    staleTime: 60_000,
    queryFn: async () => {
      const sevenDaysAgo = new Date();
      sevenDaysAgo.setDate(sevenDaysAgo.getDate() - 7);

      const { data, error, count } = await supabase
        .from("edge_function_errors")
        .select("*", { count: "exact" })
        .gte("created_at", sevenDaysAgo.toISOString())
        .order("created_at", { ascending: false })
        .limit(10);

      if (error) throw error;

      return {
        errors: (data ?? []) as EdgeFunctionError[],
        totalCount: count ?? 0,
      };
    },
  });
}
